<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{ name: string; seed: string; size?: 'md' | 'lg' }>(), {
  size: 'md',
});

const initials = computed(() => {
  const parts = props.name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '?';
  const last = parts.length > 1 ? (parts.at(-1)?.[0] ?? '') : '';
  return (first + last).toUpperCase();
});

/** Stable hue per user, so their avatar color never changes. */
const hue = computed(() => {
  let h = 0;
  for (const ch of props.seed) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return String(h);
});
</script>

<template>
  <span
    class="avatar"
    :class="{ 'avatar--lg': size === 'lg' }"
    :style="{ '--avatar-hue': hue }"
    aria-hidden="true"
  >
    {{ initials }}
  </span>
</template>
